export const RETURN_CENTER_ADDRESS = {
  company: 'The Home Depot 106',
  addressLine1: '449 Roberts Ct,',
  city: 'Kennesaw',
  state: 'GA',
  zip: '30144',
} as const;

// Page capacity estimates (12px font, ~29px/row)
// Android WebView has a tighter printable area than desktop browsers,
// so capacities are conservative to avoid blank overflow pages.
export const ITEMS_PAGE_1_MULTI = 24; // first page when there are multiple pages
export const ITEMS_PAGE_1_SINGLE = 11; // first page when all items fit (includes instructions)
export const ITEMS_MIDDLE_PAGE = 33; // continuation pages (no notice or instructions)
export const ITEMS_LAST_PAGE = 16; // last page (includes return instructions)
